import {ReactElement} from "react";
import {SectionContainer} from "./SharedComponents";
import {StyledBoxColumn, StyledBoxRow, StyledHeadingVariant, StyledSpan} from "@/shared/StyledComponents";
import {Button, Grid, Typography} from "@mui/material";
import {ArrowForwardIosOutlined, ArrowForwardOutlined} from "@mui/icons-material";
import {BORDER_RADIUS_LARGE, CARD_SHADOW, PD_LG, PD_MD, PD_SM} from "@/shared/dimens";
import {gray} from "@/shared/colors";
import {SERVICE_TYPE_KTM, ServicesDisplayMode, ServicesSectionData} from "../../types";

export function ServicesSection(props: { data: ServicesSectionData }): ReactElement {
  return <SectionContainer>
    <StyledBoxColumn style={{gap: PD_SM}}>
      {props.data.title
        ? <StyledHeadingVariant default_={3}>{props.data.title}</StyledHeadingVariant>
        : null}
      {props.data.subtitle
        ? <Typography style={{opacity: 0.6, lineHeight: 1.7, maxWidth: 600}}>{props.data.subtitle}</Typography>
        : null}
    </StyledBoxColumn>
    {props.data.displayMode === ServicesDisplayMode.STANDARD
      ? <Grid container>
        {props.data.services.map((service, i) =>
          <Grid key={i} xs={12} sm={6} md={4} style={{display: "flex", padding: PD_MD}}>
            <div style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              borderRadius: BORDER_RADIUS_LARGE,
              boxShadow: CARD_SHADOW,
              overflow: "hidden",
              backgroundColor: "#fff",
            }}>
              <img
                style={{
                  width: "100%",
                  aspectRatio: 16 / 9,
                  background: gray,
                  objectFit: "cover",
                }}
                src={service.imageUrl || SERVICE_TYPE_KTM.findMetadata(service.type)?.imageUrl}
              />
              <StyledBoxColumn style={{
                flex: 1,
                padding: PD_LG,
                gap: PD_MD,
              }}>
                <StyledBoxColumn style={{gap: PD_SM}}>
                  <Typography variant="h6">
                    {service.title}
                  </Typography>
                  {service.description
                    ? <Typography style={{opacity: 0.65, lineHeight: 1.7}}>
                      {service.description}
                    </Typography>
                    : null}
                </StyledBoxColumn>
                {service.link?.text
                  ? <Button
                    href={service.link.url}
                    variant="text"
                    endIcon={<ArrowForwardOutlined/>}
                    style={{alignSelf: "flex-start", marginLeft: -PD_LG}}>
                    {service.link.text}
                  </Button>
                  : null}
              </StyledBoxColumn>
            </div>
          </Grid>
        )}
      </Grid>
      : null}
    {props.data.displayMode === ServicesDisplayMode.COMPACT
      ? <Grid container>
        {props.data.services.map((service, i) =>
          <Grid key={i} xs={12} md={6} style={{padding: PD_MD}}>
            <Button
              href={service.link.url}
              style={{
                borderRadius: BORDER_RADIUS_LARGE,
                height: 100,
                width: "100%",
                boxShadow: CARD_SHADOW,
                backgroundColor: "#fff",
              }}>
              <StyledBoxRow style={{width: "100%", alignItems: "center", gap: PD_LG, padding: `0 ${PD_MD}px`}}>
                <img
                  style={{
                    height: 72,
                    borderRadius: PD_MD,
                    aspectRatio: 16 / 9,
                    background: gray,
                    objectFit: "cover",
                  }}
                  src={service.imageUrl || SERVICE_TYPE_KTM.findMetadata(service.type)?.imageUrl}
                />
                <StyledHeadingVariant default_={5} max={6}>{service.title}</StyledHeadingVariant>
                <StyledSpan/>
                <ArrowForwardIosOutlined style={{opacity: 0.4, fontSize: 16}}/>
              </StyledBoxRow>
            </Button>
          </Grid>
        )}
      </Grid>
      : null}
  </SectionContainer>;
}
